import React from "react";
import PropTypes from "prop-types";
//Material imports
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import Button from "@mui/material/Button";
const Arrow = ({
  direction,
  clickFunction,
  disable
}) => /*#__PURE__*/React.createElement(Button, {
  size: "small",
  onClick: clickFunction,
  disabled: disable
}, direction === "right" ? /*#__PURE__*/React.createElement(KeyboardArrowRight, null) : /*#__PURE__*/React.createElement(KeyboardArrowLeft, null));
const CarouselComponent = ({
  contentComponent,
  contentArr,
  contentStyles
}) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const lastIndex = contentArr.length - 1;
  const previousSlide = () => {
    const shouldResetIndex = currentIndex === 0;
    const index = shouldResetIndex ? lastIndex : currentIndex - 1;
    setCurrentIndex(index);
  };
  const nextSlide = () => {
    const shouldResetIndex = currentIndex === lastIndex;
    const index = shouldResetIndex ? 0 : currentIndex + 1;
    setCurrentIndex(index);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: contentStyles
  }, /*#__PURE__*/React.createElement(Arrow, {
    direction: "left",
    clickFunction: previousSlide,
    disable: currentIndex === 0
  }), contentComponent(contentArr[currentIndex].text), /*#__PURE__*/React.createElement(Arrow, {
    direction: "right",
    clickFunction: nextSlide,
    disable: currentIndex === lastIndex
  }));
};
CarouselComponent.propTypes = {
  contentComponent: PropTypes.func,
  contentArr: PropTypes.array.isRequired,
  contentStyles: PropTypes.string
};
Arrow.propTypes = {
  direction: PropTypes.string,
  clickFunction: PropTypes.func,
  disable: PropTypes.bool
};
export default CarouselComponent;